import { test } from 'ramda';

const isRootRelativeURL = test(/^\//);

const DOMAIN_DEV = 'http://localhost:3000';
const DOMAIN_PREPROD = 'https://www.preprod.groupelaposte.com';
const DOMAIN_PROD = 'https://www.groupelaposte.com';
const DOMAIN_RECETTE = 'https://www.recette.groupelaposte.com';

export const getDomain = /* istanbul ignore next */ () => {
  if (
    process.env.NODE_ENV !== 'production' ||
    process.env.RAZZLE_LOCAL !== 'false'
  ) {
    return DOMAIN_DEV;
  }

  if (process.env.RAZZLE_ENV === 'recette') {
    return DOMAIN_RECETTE;
  }

  if (process.env.RAZZLE_ENV !== 'prod') {
    return DOMAIN_PREPROD;
  }

  return DOMAIN_PROD;
};

/**
 * A function to prefix an url with server root (if it is define)
 *
 * @param {string} url
 * @return {string}
 * @example fromRoot('/toto') === https://www.trololo/toto
 */
export const fromRoot = (url) => {
  if (isRootRelativeURL(url) && process && process.env.RAZZLE_ASSETS_PREFIX) {
    return `${process.env.RAZZLE_ASSETS_PREFIX}${url}`;
  }

  return url;
};

export default fromRoot;
